import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import CardFace from "../components/CardFace";
import CardDetailModal from "../components/CardDetailModal";
import { ArrowLeft } from "lucide-react";

export default function ShareView() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    api.get(`/share/${token}`).then((r) => setData(r.data)).catch(() => setErr(true));
  }, [token]);

  return (
    <div className="min-h-screen max-w-md sm:max-w-2xl lg:max-w-5xl mx-auto px-4 py-6">
      <Link to="/" className="pill-soft inline-flex items-center gap-1.5 px-4 py-2 text-sm mb-4">
        <ArrowLeft size={15} /> Vai a Lumacofono
      </Link>
      <h1 className="font-display font-bold text-2xl text-gradient">Collezione condivisa</h1>
      <p className="luma-muted text-sm font-semibold mb-4">Vista di sola lettura</p>

      {err && <div className="luma-card p-6 text-center luma-muted">Questa collezione non è disponibile.</div>}
      {data && (
        <>
          <div className="grid grid-cols-3 gap-2 mb-4">
            {[
              ["Numeri carta", `${data.stats.unique_cards}/${data.stats.total_cards}`],
              ["Artwork", data.stats.unique_variants],
              ["Carte", data.items.length],
            ].map(([k, v]) => (
              <div key={k} className="luma-card !rounded-2xl p-2.5 text-center">
                <div className="font-display font-bold text-base">{v}</div>
                <div className="text-[10px] luma-muted font-bold uppercase tracking-wide">{k}</div>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-5 gap-2.5">
            {data.items.map((c) => (
              <CardFace key={c.variant_id} card={c} imagesEnabled onClick={() => setDetail(c)} />
            ))}
          </div>
        </>
      )}
      {detail && <CardDetailModal card={detail} imagesEnabled onClose={() => setDetail(null)} />}
    </div>
  );
}
